"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ToLong_1 = require("./ToLong");
var NetworkAddress_1 = require("./NetworkAddress");
var BroadcastAddress_1 = require("./BroadcastAddress");
function contains(network, ipaddress) {
    var firsAddress = ToLong_1.toLong(NetworkAddress_1.networkAddress(network));
    var lastAddress = ToLong_1.toLong(BroadcastAddress_1.broadcastAddress(network));
    return (ToLong_1.toLong(ipaddress) >= firsAddress) && (ToLong_1.toLong(ipaddress) <= lastAddress);
}
exports.contains = contains;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGFpbnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJDb250YWlucy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLG1DQUFpQztBQUNqQyxtREFBaUQ7QUFDakQsdURBQXFEO0FBRXJELGtCQUEwQixPQUFlLEVBQUUsU0FBaUI7SUFDMUQsSUFBSSxXQUFXLEdBQUcsZUFBTSxDQUFDLCtCQUFjLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQTtJQUNqRCxJQUFJLFdBQVcsR0FBRyxlQUFNLENBQUMsbUNBQWdCLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQTtJQUNuRCxNQUFNLENBQUMsQ0FBQyxlQUFNLENBQUMsU0FBUyxDQUFDLElBQUksV0FBVyxDQUFDLElBQUksQ0FBQyxlQUFNLENBQUMsU0FBUyxDQUFDLElBQUksV0FBVyxDQUFDLENBQUE7QUFDakYsQ0FBQztBQUpELDRCQUlDIn0=


//////////////////
// WEBPACK FOOTER
// ./src/Contains.ts
// module id = 16
// module chunks = 0